// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import catalog from '../../machines/catalog.json'

const definitions = import.meta.glob('../../machines/*/machine.json', { query: '?raw', import: 'default' })
export const STOCK_MACHINES = catalog.machines
export type StockAccess = 'allowed' | 'needs-pro' | 'offline'
export const stockMachine = (id: string): (typeof catalog.machines)[number] | undefined => catalog.machines.find((entry) => entry.id === id)

/** Only catalogue-pinned original stock data; no path or code is accepted from a player. */
export async function readStockMachine(id: string): Promise<unknown> {
  const entry = stockMachine(id)
  const load = definitions[`../../machines/${id}/machine.json`]
  if (entry === undefined || load === undefined) throw new Error('Packaged machine is unavailable')
  const raw = await load()
  if (typeof raw !== 'string') throw new Error('Packaged machine has no source bytes')
  const bytes = new TextEncoder().encode(raw)
  if (bytes.length > 2 * 1024 * 1024) throw new Error('Packaged machine exceeds its source budget')
  const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', bytes))
  const hash = [...digest].map((byte) => byte.toString(16).padStart(2, '0')).join('')
  if (hash !== entry.definitionHash) throw new Error('Packaged machine source hash does not match the catalogue')
  const definition = JSON.parse(raw) as { machineId?: unknown; machineVersion?: unknown }
  if (definition.machineId !== id || definition.machineVersion !== entry.version) throw new Error('Packaged machine identity does not match the card')
  return definition
}
